import { Container } from '@acies/core';
import theme from './theme';

export default class Divider extends Container {
	public constructor() {
		super();
		this.fill = theme.colors.fill.soft;
		this.height = 1;
		this.width = 'fill';
	}
}
customElements.define('ac-divider', Divider);
